(function($) {
  $('body').addClass(bowser.name.toLowerCase()+"-"+bowser.version);
  $('body').addClass(bowser.osname.toLowerCase()+"-"+bowser.osversion);
    if(bowser.mobile){
    $('body').addClass('mobile')
  } else if(bowser.tablet){
    $('body').addClass('tablet')
  } else {
    $('body').addClass('desktop')
  }
})(jQuery);
